import React, { useEffect, useState } from 'react'
import { getImages } from '../Common/const'
import ModalLayout from '../Common/ModalLayout'
import AutomotiveJobsModal from '../Components/AutomotiveJobs/AutomotiveJobsModal';
import SeoMeta from '../Common/SeoMeta';
import { useContext } from 'react';
import { VehicleContext } from '../Context/VehicleContext';

const AutomotiveJobs = () => {
    const { getCMSData } = useContext(VehicleContext);
    const [cmsData, setCMSData] = useState({});
    const getPageData = async () => {
        setCMSData(await getCMSData('careers'));
    }
    useEffect(() => {
        getPageData();
    }, []);
    const getCMSValue = (field) => {
        return field in cmsData ? cmsData[field] : "";
    }
    const [openApplicationModal, setOpenApplicationModal] = useState(false);
    const [openLocationName, setLocationName] = useState(false);
    const handleApplicationModal = (locationName) => {
        setOpenApplicationModal(true);
        setLocationName(locationName);
        document.body.classList.add('body-overflow');
    }
    const closeApplicationModal = () => {
        setOpenApplicationModal(false);
        setLocationName("");
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <SeoMeta
                title="Automotive jobs Tampa, FL and San Clemente, CA at European Exotic Center"
                description="Are you looking for automotive jobs in Tampa, FL and San Clemente, CA? European Exotic Center is always looking for car salesmen and auto repair technicians, apply today."
                keywords=""
                ogTitle="Automotive jobs Tampa, FL and San Clemente, CA at European Exotic Center"
                ogDescription="Are you looking for automotive jobs in Tampa, FL and San Clemente, CA? European Exotic Center is always looking for car salesmen and auto repair technicians, apply today."
            />
            <section className="common-banner-wrap repair-banner consign-banner">
                <img src={getImages('automotive-hero-banner.webp')} alt='automotive' />
                <div className="container">
                    <div className='common-banner-pos pt-5 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>{getCMSValue('careerMainHeading')}</h1>
                        <div className='md-title font-2em fw-500 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>{getCMSValue('careerSubHeading')}</div>
                    </div>
                </div>
            </section>
            <section className='automotive-job-wrap'>
                <div className='container mxw-1170'>
                    <h1 className='lg-title font-2-5em text-uppercase mb-3 wow reveal fadeInUp'>{getCMSValue('careerContentMainHeading')}</h1>
                    <h2 className='lg-title font-1-9em text-uppercase mb-4 text-orange text-uppercase wow reveal fadeInUp'>{getCMSValue('careerContentSubHeading')}</h2>
                    <div className='common-text wow reveal fadeInUp'>
                        <p>{getCMSValue('careerContentText')}</p>
                    </div>
                    <div className='row justify-content-between mt-100 mlr-70'>
                        <div className='col-md-6 wow reveal fadeInLeft'>
                            <div className='aj-box'>
                                <div className='text-center'>
                                    <div className='xs-title font-1-2em fw-700 text-uppercase d-inline-flex align-items-center'>
                                        <img className='me-3' src={getImages('ca.svg')} />
                                        <div>{getCMSValue('careerCard1Title')}</div>
                                    </div>
                                </div>
                                <p>{getCMSValue('careerCard1Text')}</p>
                                <div className='text-center'>
                                    <button type='button' onClick={()=>handleApplicationModal("San Clemente, CA")} className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'>Apply Now</button>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInRight'>
                            <div className='aj-box'>
                                <div className='text-center'>
                                    <div className='xs-title font-1-2em fw-700 text-uppercase d-inline-flex align-items-center'>
                                        <img className='me-3' src={getImages('fl.svg')} />
                                        <div>{getCMSValue('careerCard2Title')}</div>
                                    </div>
                                </div>
                                <p>{getCMSValue('careerCard2Text')}</p>
                                <div className='text-center'>
                                    <button type='button' onClick={()=>handleApplicationModal("Tampa, FL")} className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'>Apply Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {openApplicationModal &&
                <ModalLayout open={openApplicationModal} close={closeApplicationModal} darkThemeCls='true' modalWidth={1040}>
                    <AutomotiveJobsModal 
                        close={closeApplicationModal}
                        openLocationName={openLocationName}
                    />
                </ModalLayout>
            }
        </>
    )
}

export default AutomotiveJobs